import { SxProps, Theme } from "@mui/material";
import { patternSecondary, primary } from "theme/palette";
import { P } from "theme/typography";

interface TagProps {
  variant: "profileField" | "hitDescription";
  tag: string;
  sx?: SxProps<Theme>;
}

const Tag = (props: TagProps) => {
  const { tag, variant } = props;
  const sx = props.sx || {};
  const backgroundColor = variant === "profileField" ? patternSecondary[50] : primary[50];
  const color = variant === "profileField" ? "patternSecondary.dark" : "primary.dark";

  return (
    <P
      sx={{
        ...{
          backgroundColor,
          color,
          padding: 0.5,
          borderRadius: 0.5,
          display: "inline-block",
        },
        ...sx,
      }}>
      {tag}
    </P>
  );
};

export default Tag;
